<template>
    <Modal size="md" @close="close">
        <div class="text-center text-sm">
            <img
                :alt="influencer.name"
                :src="influencer.avatar_url"
                class="spark-profile-photo-xl mx-auto mb-5"
            />

            <h3>{{ influencer.name }}</h3>

            <p class="m-5">
                Vælger du at godkende en anmodning, vil
                <strong class="">jobbet blive sat igang</strong>, og influenten vil
                modtage besked. Nedenstående beløb vil blive hævet på dit tilknyttede
                betalingsmiddel. Influenten modtager først beløbet,
                <strong class="">når jobbet er færdigt</strong>.
            </p>

            <div class="m-lg text-left">
                <table class="table">
                    <thead>
                        <tr>
                            <th>Job</th>
                            <th>Betaling</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                {{ job.jobable.name }}
                            </td>
                            <td>
                                <Amount
                                    :value="job.influencer_cost"
                                    :decimals="2"
                                    class="flex"
                                ></Amount>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                betterhype Fee ({{ brandFeePercent * 100 }}%)
                                <div class="small">
                                    herunder moms
                                </div>
                            </td>
                            <td>
                                <Amount :value="job.brand_fee" :decimals="2" class="flex"></Amount>
                                <Amount
                                    :value="job.brand_fee_vat"
                                    :decimals="2"
                                    class="flex small"
                                ></Amount>
                            </td>
                        </tr>

                        <tr>
                            <th>Total</th>
                            <th>
                                <Amount :value="job.brand_cost" :decimals="2" class="flex"></Amount>
                            </th>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div v-if="!brand.has_payment_method">
                <div class="alert alert-warning">
                    Du har endnu ikke tilføjet nogen betalingsmetode. Kom igang ved at tilføje en
                    nu.
                </div>
                <button
                    class="btn btn-load btn-xl btn-success"
                    :disabled="form.busy"
                    @click="openPaymentMethodModal"
                >
                    Tilføj betalingsmetode
                </button>
            </div>
            <div v-else>
                <form-item :form="form" field="terms" help-block-label="Betingelser">
                    <div class="checkbox m-b-lg">
                        <label>
                            <input v-model="form.terms" type="checkbox" /> Jeg accepterer
                            <a href="/terms" target="_blank">betterhypes betingelser</a>
                        </label>
                    </div>
                </form-item>

                <div v-if="form.errors.has('stripe_charge')" class="alert alert-danger">
                    Vi kunne ikke hæve penge på dit betalingskort der slutter på **** **** ****
                    <b>@{{ brand.card_last_four }}</b
                    >. Kontroller der er tilstrækkeligt med midler på kortet, eller
                    <a href="#" @click.prevent="openPaymentMethodModal">skift dit betalingskort</a>.
                </div>

                <button
                    class="btn btn-load btn-xl btn-success"
                    :disabled="form.busy"
                    @click="accept"
                >
                    Start samarbejde
                </button>
            </div>
        </div>
    </Modal>
</template>
<script type="text/babel">
import Amount from 'dashboard-js/components/utilities/Amount'
import Modal from 'dashboard-js/components/Modal'

export default {
    components: { Modal, Amount },

    props: ['job', 'brand'],

    data() {
        return {
            form: new SparkForm({
                terms: false,
            }),
        }
    },

    computed: {
        brandFeePercent() {
            return Spark.config.billing.brand_fee_percent
        },

        influencer() {
            return this.job.influencer
        },
    },

    methods: {
        accept() {
            Spark.post(`/api/jobs/${this.job.id}/accept`, this.form).then(response => {
                // redirect to payment auth page
                if (response.redirect_url) {
                    window.location.href = response.redirect_url
                }

                this.close()

                Bus.$emit('jobUpdated', response.data)
            })
        },

        close() {
            this.$emit('close')
        },

        openPaymentMethodModal() {
            this.$emit('open-payment')
        },
    },
}
</script>
